import { createSelector } from "@reduxjs/toolkit";
import { selectCurrentQueryResults } from "views/logic/slices/viewSelectors";
import useViewsSelector from "views/stores/useViewsSelector";
const selectCurrentSearchTypeResults = createSelector(selectCurrentQueryResults, (result) => result == null ? void 0 : result.searchTypes);
const useCurrentSearchTypesResults = () => useViewsSelector(selectCurrentSearchTypeResults);
export default useCurrentSearchTypesResults;
